import { FC } from 'react';
import { PageTitle, PageLink } from '../../../_metronic/layout/core';
import { View } from './components/View';
import { useParams } from 'react-router-dom';
import { decryptId } from '../../../_metronic/helpers';

const NoteTaskPage: FC = () => {
  const { id_tarea, id } = useParams<{ id_tarea: string; id: string }>();

  const noteId = decryptId(id);
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Tareas',
      path: '/bitacora/bitacora/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: 'Editar',
      path: `/bitacora/tarea/edit/${id_tarea}`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: 'Notas',
      path: `/bitacora/tarea/edit/${id_tarea}`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>
        {noteId ? 'Editar nota' : 'Nueva nota'}
      </PageTitle>

      <View id={noteId ? noteId : '0'} />
    </>
  );
};

export { NoteTaskPage };
